import { useContext, useEffect, useState } from 'react';
import { CalendarDateRangeIcon, BanknotesIcon, BuildingLibraryIcon, CreditCardIcon, CubeIcon, DevicePhoneMobileIcon, DeviceTabletIcon, EnvelopeIcon, HashtagIcon, Square3Stack3DIcon, UserCircleIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CalendarIcon, PaperClipIcon, TagIcon, CheckIcon } from '@heroicons/react/20/solid'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'


import { convertDateTimeToFormat, mergeClassNames } from '../../utils/utils';
import { SupportContext } from '../../../hoc/SupportContext';

import CustomerServiceIcon from '../../../lottie/customer-service';
import Lottie from 'react-lottie-player';

const assignees = [
    { name: 'Unassigned', value: null },
    {
        name: 'Wade Cooper',
        value: 'wade-cooper',
        avatar:
            'https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    // More items...
]
const labels = [
    { name: 'Unlabelled', value: null },
    { name: 'Engineering', value: 'engineering' },
    // More items...
]
const dueDates = [
    { name: 'No due date', value: null },
    { name: 'Today', value: 'today' },
    // More items...
]

const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
          case 'success': return 'bg-green-100 text-green-800';
          case 'failed': return 'bg-red-100 text-red-800';
          case 'cancelled': return 'bg-gray-100 text-gray-800';
          case 'pending': return 'bg-yellow-100 text-yellow-800';
          case 'suspended': return 'bg-orange-100 text-orange-800';
          default: return 'bg-gray-100 text-gray-800';
        }
      };



const TicketDetails = (props) => {
    //const {singleTicket} = props;
    const [assigned, setAssigned] = useState(assignees[0])
    const [labelled, setLabelled] = useState(labels[0])
    const [dated, setDated] = useState(dueDates[0])


    const { singleTicket, changeTicketStatus, addResponse, submitLoader, setResponseTextGiven, responseTextGiven, handleFileUpload, selectedFile, resetFile, handleUserTransactionHistory, transactionHistory, userTab, setUserTab } = useContext(SupportContext);




    // useEffect(() => {
    //     setSelected(currentTab)
    // },[currentTab])

    // console.log(ticketStatus)
    //const {singleTicket} = useTickets();

    const [open, setOpen] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null);

    
    const sortedResponses = singleTicket?.ticket_responses && [...singleTicket?.ticket_responses].sort(
     (a, b) => a.id - b.id
   );


    return (
        <>
            <div className='sm:w-2/3 bg-white text-gray-500 h-[508px]'>
                <div className='bg-white sm:flex sm:gap-px sm:divide-y-0 h-[508px]'>
                    <div className='sm:w-2/3 bg-white text-gray-500 flex flex-col' style={(singleTicket ?? {width: '100%'})}>
                        <div className={`overflow-auto ${singleTicket && 'h-96'} px-6 py-6 grow ...`} style={(singleTicket ?? {height: '34rem'})}>
                            {singleTicket ? <>
                                <div className='border-b border-slate-100 mb-4 pb-3'>
                                    <>
                                        <div className='flex items-center justify-between mb-3'>
                                            <div className="">
                                                <p className="text-xs mb-1">Ticket ID: <span className="font-black">{singleTicket.ticketId}</span></p>
                                                <p className='text-xs flex'>
                                                    <CalendarDateRangeIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                                    Created: <time>{convertDateTimeToFormat(singleTicket.created_at, 2)}</time>

                                                </p>
                                            </div>
                                            <div className='flex items-center gap-2'>
                                                <p className="text-xs">Status: </p>
                                                <Listbox value={singleTicket.status} onChange={changeTicketStatus}>
                                                    <div className="relative w-24">
                                                        <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-2 pl-3 pr-2 text-left text-xs text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-red-600">
                                                            <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                                                <span className="block truncate">{singleTicket.status}</span>
                                                            </span>
                                                            <ChevronUpDownIcon
                                                                aria-hidden="true"
                                                                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                            />
                                                        </ListboxButton>

                                                        <ListboxOptions
                                                            transition
                                                            className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                                        >
                                                            {["Open", "In Progress", "Resolved", "Closed"].map((person) => (
                                                                <ListboxOption
                                                                    key={person}
                                                                    value={person}
                                                                    className="group relative cursor-default select-none py-1.5 text-gray-900 data-[focus]:bg-red-600 data-[focus]:text-white data-[focus]:outline-none"
                                                                >
                                                                    <div className="flex items-center">
                                                                        <span className="ml-3 block truncate text-xs group-data-[selected]:font-semibold">
                                                                            {person}
                                                                        </span>
                                                                    </div>

                                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-red-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                                                        <CheckIcon aria-hidden="true" className="size-3" />
                                                                    </span>
                                                                </ListboxOption>
                                                            ))}
                                                        </ListboxOptions>
                                                    </div>
                                                </Listbox>
                                            </div>
                                        </div>
                                        <p className="text-xl/6 font-bold text-gray-900">{singleTicket.title}</p>
                                    </>
                                </div>
                                <div>
                                    <p className="text-sm/6  text-gray-900">{singleTicket.description}</p>
                                    <div className='grid grid-cols-5 gap-4 mt-4'>
                                        {/* {singleTicket?.ticket_attachments?.length > 0 ? singleTicket.ticket_attachments.map((imageObj) => {
                                        return <div className='' key={imageObj.id}>
                                                    <img src={imageObj.url} alt='' onClick={() => setOpen(true)} class="aspect-[4/5] flex-none rounded-2xl object-cover outline outline-1 -outline-offset-1 outline-black/5 cursor-pointer" />
                                                    <Dialog open={open} onClose={setOpen} className="relative z-20">
                                                        <DialogBackdrop
                                                        transition
                                                        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in dark:bg-gray-900/50"
                                                        />

                                                        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                                            <DialogPanel
                                                            transition
                                                            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                                                            >
                                                            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                                                <button
                                                                type="button"
                                                                onClick={() => setOpen(false)}
                                                                className="rounded-md p-2 bg-white text-gray-400 hover:text-red-500 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-indigo-600"
                                                                >
                                                                <span className="sr-only">Close</span>
                                                                <XMarkIcon aria-hidden="true" className="size-6" />
                                                                </button>
                                                            </div>
                                                            <div className="sm:flex sm:items-start">
                                                                <img src={imageObj.url} alt=''  class="aspect-[4/5] flex-none rounded-2xl object-cover outline outline-1 -outline-offset-1 outline-black/5" />
                                                            </div>
                                                            </DialogPanel>
                                                        </div>
                                                        </div>
                                                    </Dialog>
                                                </div>
                                    }) : ''} */}
                                    {singleTicket?.ticket_attachments?.length > 0 &&
        singleTicket.ticket_attachments.map((imageObj) => (
          <div key={imageObj.id}>
            <img
              src={imageObj.url}
              alt=""
              onClick={() => setSelectedImage(imageObj.url)}
              className="aspect-[4/5] flex-none rounded-2xl object-cover outline outline-1 -outline-offset-1 outline-black/5 cursor-pointer"
            />
          </div>
        ))}


        

      <Dialog
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        className="relative z-20"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity dark:bg-gray-900/50" />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:w-full sm:max-w-lg sm:p-6">
              <button
                type="button"
                onClick={() => setSelectedImage(null)}
                className="absolute right-3 top-3 rounded-md p-2 bg-white text-gray-400 hover:text-red-500"
              >
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>

              <img
                src={selectedImage}
                alt="Preview"
                className="aspect-[4/5] w-full rounded-2xl object-cover outline outline-1 -outline-offset-1 outline-black/5"
              />
            </DialogPanel>
          </div>
        </div>
      </Dialog>
                                    </div>
                                </div>
                                
                                {singleTicket?.ticket_responses?.length > 0 &&
                                <div className='mt-3 pt-3 relative bg-white border-b-4 lg:border-b-0'>
                                        <ul className="relative border-s border-default list-none">
                                            {sortedResponses.map((ticketReponse) => (
                                                <li
                                                    key={ticketReponse.id}
                                                    className="mb-10 ms-6"
                                                >
                                                    <span class="absolute flex items-center justify-center w-6 h-6 bg-gray-50 rounded-full -start-3 ring-1 ring-buffer ring-gray-300">
                                                        <svg class="w-3 h-3 text-fg-brand-strong" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"/></svg>
                                                    </span>
                                                    <div className='flex items-center gap-2 mb-2'>
                                                        <time className="bg-neutral-secondary-medium border border-default-medium text-heading text-[10px] font-medium px-2.5 py-1 rounded-full" dateTime={ticketReponse.created_at}>{convertDateTimeToFormat(ticketReponse.created_at, 3)}</time>
                                                        {ticketReponse.agent_id !== null &&
                                                        <p className="bg-red-50 border border-red-100 text-red-700 text-heading text-[10px] font-medium px-2.5 py-0.5 rounded-full uppercase">
                                                            {ticketReponse.agent_id !== null ? 'Support Team' : 'Customer'}
                                                        </p> }
                                                        {ticketReponse.user_id !== null &&
                                                        <p className="bg-green-50 border border-green-100 text-green-700 text-heading text-[10px] font-medium px-2.5 py-0.5 rounded-full uppercase">
                                                            {ticketReponse.user_id !== null ? 'Customer' : 'Support Team'}
                                                        </p> }
                                                    </div>
                                                    <div className="min-w-0">
                                                        <div className="flex flex-col items-start gap-x-3">
                                                            <p class="mb-4 text-body text-sm">{ticketReponse.message}</p>
                                                            {ticketReponse?.ticket_attachments?.length > 0 &&
                                                                ticketReponse?.ticket_attachments.map((attachment) => {
                                                                    let files = JSON.parse(attachment.file_url)
                                                                    let imageArray = Array.isArray(files) ? files : [files];
                                                                    return <div className='grid grid-cols-5 gap-4'>{imageArray.map((imageObj) => {
                                                                        console.log(imageObj)
                                                                        return (<div key={imageObj.id}>
                                                                            <img
                                                                                src={imageObj.url}
                                                                                alt=""
                                                                                onClick={() => setSelectedImage(imageObj.url)}
                                                                                className="aspect-[4/5] flex-none rounded-2xl object-cover outline outline-1 -outline-offset-1 outline-black/5 cursor-pointer"
                                                                            />
                                                                        </div>)
                                                                    }
                                                                    )}</div>
                                                                })}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>                        
                                    </div>}



          
                                </> :
                                <>
                                    <div className='flex items-center justify-center flex-col h-full -mt-10 -ml-10'>
                                        <div className="mx-auto flex size-48 items-center justify-center0">
                                            <Lottie animationData={CustomerServiceIcon} play loop />
                                        </div>
                                        <h3 className='text-xl font-bold text-center mb-2 text-black'>Build Better Relationships</h3>
                                        <p className='text-center text-sm'>One Ticket at a Time.</p>
                                    </div>
                                </>
                            }
                            {/* <ul role="list" className="space-y-6">
                                                    {activity.map((activityItem, activityItemIdx) => (
                                                        <li key={activityItem.id} className="relative flex gap-x-4">
                                                            <div
                                                                className={classNames(
                                                                    activityItemIdx === activity.length - 1 ? 'h-6' : '-bottom-6',
                                                                    'absolute left-0 top-0 flex w-6 justify-center',
                                                                )}
                                                            >
                                                                <div className="w-px bg-gray-200" />
                                                            </div>
                                                            {activityItem.type === 'commented' ? (
                                                                <>
                                                                    <img
                                                                        alt=""
                                                                        src={activityItem.person.imageUrl}
                                                                        className="relative mt-3 size-6 flex-none rounded-full bg-gray-50"
                                                                    />
                                                                    <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">
                                                                        <div className="flex justify-between gap-x-4">
                                                                            <div className="py-0.5 text-xs/5 text-gray-500">
                                                                                <span className="font-medium text-gray-900">{activityItem.person.name}</span> commented
                                                                            </div>
                                                                            <time dateTime={activityItem.dateTime} className="flex-none py-0.5 text-xs/5 text-gray-500">
                                                                                {activityItem.date}
                                                                            </time>
                                                                        </div>
                                                                        <p className="text-sm/6 text-gray-500">{activityItem.comment}</p>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="relative flex size-6 flex-none items-center justify-center bg-white">
                                                                        {activityItem.type === 'paid' ? (
                                                                            <CheckCircleIcon aria-hidden="true" className="size-6 text-indigo-600" />
                                                                        ) : (
                                                                            <div className="size-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />
                                                                        )}
                                                                    </div>
                                                                    <p className="flex-auto py-0.5 text-xs/5 text-gray-500">
                                                                        <span className="font-medium text-gray-900">{activityItem.person.name}</span> {activityItem.type} the
                                                                        invoice.
                                                                    </p>
                                                                    <time dateTime={activityItem.dateTime} className="flex-none py-0.5 text-xs/5 text-gray-500">
                                                                        {activityItem.date}
                                                                    </time>
                                                                </>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul> */}
                        </div>
                        {singleTicket && <form action="#" className="relative">
                            <div className="bg-white border-t px-4 py-2">
                                <label htmlFor="description" className="sr-only">
                                    Description
                                </label>
                                <textarea
                                    id="description"
                                    name="description"
                                    rows={2}
                                    placeholder="Write a description..."
                                    className="block w-full resize-none px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                                    value={responseTextGiven || ""}
                                    onChange={(e) => setResponseTextGiven(e.target.value)}
                                />

                                <div aria-hidden="true">
                                    <div className="py-2">
                                        <div className="h-5" />
                                    </div>
                                    <div className="h-px" />
                                    <div className="py-2">
                                        <div className="py-px">
                                            <div className="h-5" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute inset-x-px bottom-0" >
                                <div className="flex flex-nowrap justify-end space-x-2 px-2 py-2 sm:px-3" style={{ display: 'none' }}>
                                    <Listbox as="div" value={assigned} onChange={setAssigned} className="shrink-0">
                                        <Label className="sr-only">Assign</Label>
                                        <div className="relative">
                                            <ListboxButton className="relative inline-flex items-center whitespace-nowrap rounded-full bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3">
                                                {assigned.value === null ? (
                                                    <UserCircleIcon aria-hidden="true" className="size-5 shrink-0 text-gray-300 sm:-ml-1" />
                                                ) : (
                                                    <img alt="" src={assigned.avatar} className="size-5 shrink-0 rounded-full" />
                                                )}

                                                <span
                                                    className={mergeClassNames(
                                                        assigned.value === null ? '' : 'text-gray-900',
                                                        'hidden truncate sm:ml-2 sm:block sm:text-xs',
                                                    )}
                                                >
                                                    {assigned.value === null ? 'Assign' : assigned.name}
                                                </span>
                                            </ListboxButton>

                                            <ListboxOptions
                                                transition
                                                className="absolute right-0 z-10 mt-1 max-h-56 w-52 overflow-auto rounded-lg bg-white py-3 text-base shadow outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                            >
                                                {assignees.map((assignee) => (
                                                    <ListboxOption
                                                        key={assignee.value}
                                                        value={assignee}
                                                        className="cursor-default select-none bg-white px-3 py-2 data-[focus]:relative data-[focus]:bg-gray-100 data-[focus]:hover:outline-none"
                                                    >
                                                        <div className="flex items-center">
                                                            {assignee.avatar ? (
                                                                <img alt="" src={assignee.avatar} className="size-5 shrink-0 rounded-full" />
                                                            ) : (
                                                                <UserCircleIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
                                                            )}

                                                            <span className="ml-3 block truncate font-medium">{assignee.name}</span>
                                                        </div>
                                                    </ListboxOption>
                                                ))}
                                            </ListboxOptions>
                                        </div>
                                    </Listbox>

                                    <Listbox as="div" value={labelled} onChange={setLabelled} className="shrink-0">
                                        <Label className="sr-only">Add a label</Label>
                                        <div className="relative">
                                            <ListboxButton className="relative inline-flex items-center whitespace-nowrap rounded-full bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3">
                                                <TagIcon
                                                    aria-hidden="true"
                                                    className={mergeClassNames(
                                                        labelled.value === null ? 'text-gray-300' : 'text-gray-500',
                                                        'size-5 shrink-0 sm:-ml-1',
                                                    )}
                                                />
                                                <span
                                                    className={mergeClassNames(
                                                        labelled.value === null ? '' : 'text-gray-900',
                                                        'hidden truncate sm:ml-2 sm:block sm:text-xs',
                                                    )}
                                                >
                                                    {labelled.value === null ? 'Label' : labelled.name}
                                                </span>
                                            </ListboxButton>

                                            <ListboxOptions
                                                transition
                                                className="absolute right-0 z-10 mt-1 max-h-56 w-52 overflow-auto rounded-lg bg-white py-3 text-base shadow outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                            >
                                                {labels.map((label) => (
                                                    <ListboxOption
                                                        key={label.value}
                                                        value={label}
                                                        className="cursor-default select-none bg-white px-3 py-2 data-[focus]:relative data-[focus]:bg-gray-100 data-[focus]:hover:outline-none"
                                                    >
                                                        <div className="flex items-center">
                                                            <span className="block truncate font-medium">{label.name}</span>
                                                        </div>
                                                    </ListboxOption>
                                                ))}
                                            </ListboxOptions>
                                        </div>
                                    </Listbox>

                                    <Listbox as="div" value={dated} onChange={setDated} className="shrink-0">
                                        <Label className="sr-only">Add a due date</Label>
                                        <div className="relative">
                                            <ListboxButton className="relative inline-flex items-center whitespace-nowrap rounded-full bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3">
                                                <CalendarIcon
                                                    aria-hidden="true"
                                                    className={mergeClassNames(
                                                        dated.value === null ? 'text-gray-300' : 'text-gray-500',
                                                        'size-5 shrink-0 sm:-ml-1',
                                                    )}
                                                />
                                                <span
                                                    className={mergeClassNames(
                                                        dated.value === null ? '' : 'text-gray-900',
                                                        'hidden truncate sm:ml-2 sm:block sm:text-xs',
                                                    )}
                                                >
                                                    {dated.value === null ? 'Due date' : dated.name}
                                                </span>
                                            </ListboxButton>

                                            <ListboxOptions
                                                transition
                                                className="absolute right-0 z-10 mt-1 max-h-56 w-52 overflow-auto rounded-lg bg-white py-3 text-base shadow outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                            >
                                                {dueDates.map((dueDate) => (
                                                    <ListboxOption
                                                        key={dueDate.value}
                                                        value={dueDate}
                                                        className="cursor-default select-none bg-white px-3 py-2 data-[focus]:relative data-[focus]:bg-gray-100 data-[focus]:hover:outline-none"
                                                    >
                                                        <div className="flex items-center">
                                                            <span className="block truncate font-medium">{dueDate.name}</span>
                                                        </div>
                                                    </ListboxOption>
                                                ))}
                                            </ListboxOptions>
                                        </div>
                                    </Listbox>
                                </div>
                                <div className="flex items-center justify-between space-x-3 border-t border-gray-200 px-2 py-2 sm:px-3">
                                    {/* <div className="flex">
                                        <button
                                            type="button"
                                            className="group -my-2 -ml-2 inline-flex items-center rounded-full px-3 py-2 text-left text-gray-400"
                                        >
                                            <PaperClipIcon aria-hidden="true" className="-ml-1 mr-2 size-5 group-hover:text-gray-500" />
                                            <span className="text-sm italic text-gray-500 group-hover:text-gray-600">Attach a file</span>
                                        </button>
                                    </div> */}
                                    {/* <div className="flex">
                                        <label
                                            htmlFor="file-upload"
                                            className="group -my-2 -ml-2 inline-flex cursor-pointer items-center rounded-full px-3 py-2 text-left text-gray-400 hover:bg-gray-50"
                                        >
                                            <PaperClipIcon
                                            aria-hidden="true"
                                            className="-ml-1 mr-2 size-5 group-hover:text-gray-500"
                                            />
                                            <span className="text-sm italic text-gray-500 group-hover:text-gray-600">
                                            Attach a file
                                            </span>
                                            
                                            <input
                                            id="file-upload"
                                            type="file"
                                            className="sr-only"
                                            onChange={(e) => handleFileUpload(e.target.files[0])}
                                            />
                                        </label>
                                    </div> */}
                                    <div className="flex flex-col gap-1">
      <label
        htmlFor="file-upload"
        className="group inline-flex cursor-pointer items-center rounded-full px-3 py-2 text-gray-400 hover:bg-gray-50"
      >
        <PaperClipIcon
          aria-hidden="true"
          className="mr-2 size-5 group-hover:text-gray-500"
        />
        <span className="text-sm italic text-gray-500 group-hover:text-gray-600">
          {selectedFile ? selectedFile.name : "Attach a file"}
        </span>
        {selectedFile && (
          <button
            type="button"
            onClick={resetFile}
            className="ml-1 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-600"
          >
            <XMarkIcon className="size-4" />
          </button>
        )}
        <input
          id="file-upload"
          type="file"
          className="sr-only"
          onChange={(e) => handleFileUpload(e.target.files[0])}
        />
      </label>

      
    </div>
                                    <div className="shrink-0">
                                        <button
                                            onClick={() => addResponse(singleTicket)}
                                            type="button"
                                            disabled={submitLoader}
                                            className={`inline-flex items-center rounded-md ${submitLoader ? 'bg-gray-400' : 'bg-red-600'} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600`}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>}
                    </div>
                    {singleTicket && singleTicket.customer ? <div className='sm:w-1/3 relative bg-white border-b-4 lg:border-b-0 p-6'>
                        {/* <div className='text-sm font-bold mb-4'>Ticket Details</div> */}
                        <div className='border-b border-slate-100 mb-4 pb-4'>
                            <p className='text-xs text-slate-400 mb-2'>Customer Details</p>
                            <div className="flex items-center">
                                <div>
                                    {singleTicket.customer.profile_picture ?
                                        <figure>
                                            <img
                                                alt=""
                                                src={singleTicket.customer.profile_picture}
                                                className="inline-block size-9 rounded-full"
                                            /></figure>
                                        : ""}
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">{singleTicket.customer.first_name} {singleTicket.customer.last_name}</p>
                                    <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">User ID: {singleTicket.customer.id}</p>
                                </div>
                            </div>
                        </div>
                        <div className="border-b border-gray-200 mb-2">
                            <nav aria-label="Tabs" className="grid grid-cols-2">
                                <button
                                    onClick={() => setUserTab(1)}
                                    className={`text-center border-b px-1 py-2 text-[10px] font-bold uppercase ${userTab === 1 ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500'}  hover:border-gray-300 hover:text-gray-700`}
                                >
                                    Profile Info
                                </button>
                                <button
                                    onClick={() => {setUserTab(2);handleUserTransactionHistory(singleTicket.customer.id)}}
                                    className={`text-center border-b px-1 py-2 text-[10px] font-bold uppercase ${userTab === 2 ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500'} hover:border-gray-300 hover:text-gray-700`}
                                >
                                    Order History
                                </button>
                            </nav>
                        </div>
                        <div className='mb-4 pb-4 overflow-y-auto h-80' style={{ display: userTab === 1 ? 'block' : 'none' }}>
                            <p className='text-xs mb-3 flex'>
                                <EnvelopeIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.email ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <DevicePhoneMobileIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.mobile_no ? `+${singleTicket.customer.country_dial_code}-${singleTicket.customer.mobile_no}` : 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <MapPinIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.state_name ? `${singleTicket.customer.state_name}, ${singleTicket.customer.country_name}` : 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <UserCircleIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.payment_status ? 'Subscribed' : 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <Square3Stack3DIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.subscription_type ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <BanknotesIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.mrp_price && <strike>{singleTicket.customer.mrp_price}</strike>} &nbsp; {singleTicket.customer.sell_price ?? 'N/A'} {singleTicket.customer.currency}</p>
                            <p className='text-xs mb-3 flex'>
                                <CalendarDateRangeIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                {singleTicket.customer.duration_type ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <BuildingLibraryIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                Payment Status : <span className={`${singleTicket.customer.payment_status && singleTicket.customer.payment_status.toLowerCase() === 'success' ? 'text-green-500' : 'text-red-500'} ms-1`}>{singleTicket.customer.payment_status ?? 'N/A'}</span></p>
                            {/* <p className='text-xs mb-3 flex'>
                        <CreditCardIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                        Payment Method : UPI</p> */}
                            <p className='text-xs mb-3 flex'>
                                <HashtagIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                Transaction ID : {singleTicket.customer.transaction_id ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <HashtagIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                Razorpay ID : {singleTicket.customer.razorpay_payment_id ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <CubeIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                Bundle ID : {singleTicket.customer.bundle_id ?? 'N/A'}</p>
                            <p className='text-xs mb-3 flex'>
                                <DeviceTabletIcon aria-hidden="true" className="size-5 text-gray-500 sm:size-4 me-1" />
                                Subscribed Platform : {singleTicket.customer.device_type ?? 'N/A'}</p>
                        </div>

                         
                        {transactionHistory?.length > 0 &&
                        <div className='mb-4 pb-4 overflow-y-auto h-80' style={{ display: userTab === 2 ? 'block' : 'none' }}>
                                <ul className="">
                                    {transactionHistory.map((transaction) => (
                                        <li
                                            key={transaction.id}
                                            className={mergeClassNames(
                                                'flex items-center border-b py-2',
                                            )}
                                        >
                                            <div className="min-w-0">
                                                <div className="grid items-center gap-x-2 text-xs/5">
                                                    <p className="whitespace-nowrap text-gray-900">
                                                        Start: <time dateTime={transaction.start_date} className='text-gray-500'>{convertDateTimeToFormat(transaction.start_date, 3)}</time>
                                                    </p>
                                                    <p className="whitespace-nowrap text-gray-900">
                                                        End: <time dateTime={transaction.end_date} className='text-gray-500'>{convertDateTimeToFormat(transaction.end_date, 3)}</time>
                                                    </p>
                                                </div>
                                                <div className="flex flex-col items-start gap-x-3">
                                                    <p className="text-xs/5 font-semibold text-gray-900"><span className='text-red-700 font-bold'>{transaction.currency} {transaction.payable_amount}</span> {transaction.free_trial_duration !== 0 && <> -
                                                        <span className="inline-flex ml-1 px-2 py-0 text-[10px] font-semibold rounded-full bg-blue-100 text-blue-800 mt-1 w-fit">
                                                            Free Trial
                                                        </span>
                                                    </>}
                                                    {transaction.payment_status !== '' && <>
                                                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(transaction.payment_status)}`}>
                                                           {transaction.payment_status}
                                                        </span>
                                                    </>}
                                                    </p>
                                                    <p className="text-xs/5 font-semibold text-gray-900">TXN: <span className='text-gray-500'>{transaction.transaction_id}</span></p>
                                                    {/* <p className="text-xs/5 font-semibold text-gray-900"></p> */}
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>}
                    </div> : ""}


                </div>
            </div>
        </>
    )
}

export default TicketDetails